export default "__VITE_ASSET__f2e20410__"